import { ExistingVideos } from "./loadPanel.types";

export const existingVideos: ExistingVideos = {
    ge: {
        en: {
            breezy_ge: {
                iphone: {
                    back: [{ type: "video" } /*, { type: "image" }*/],
                    backsidebottomcorner: [{ type: "video" } /*, { type: "image" }*/],
                    backsidetopcorner: [{ type: "video" } /*, { type: "image" }*/],
                    front: [{ type: "video" } /*, { type: "image" }*/],
                    frontbattery: [{ type: "video" } /*, { type: "image" }*/],
                    frontimei: [{ type: "video" } /*, { type: "image" }*/],
                },
                smartphone: {
                    back: [{ type: "video" } /*, { type: "image" }*/],
                    backsidebottomcorner: [{ type: "video" } /*, { type: "image" }*/],
                    backsidetopcorner: [{ type: "video" } /*, { type: "image" }*/],
                    front: [{ type: "video" } /*, { type: "image" }*/],
                    frontimei: [{ type: "video" } /*, { type: "image" }*/],
                    frontmodel: [{ type: "video" } /*, { type: "image" }*/],
                },
            },
        },
    },
    md: {
        ru: {
            breezy_md: {
                iphone: {
                    backsidebottomcorner: [{ type: "video" } /*, { type: "image" }*/],
                    backsidetopcorner: [{ type: "video" } /*, { type: "image" }*/],
                    front: [{ type: "video" } /*, { type: "image" }*/],
                    frontbattery: [{ type: "video" } /*, { type: "image" }*/],
                    frontimei: [{ type: "video" } /*, { type: "image" }*/],
                },
                smartphone: {
                    back: [{ type: "video" } /*, { type: "image" }*/],
                    backsidebottomcorner: [{ type: "video" } /*, { type: "image" }*/],
                    backsidetopcorner: [{ type: "video" } /*, { type: "image" }*/],
                    front: [{ type: "video" } /*, { type: "image" }*/],
                    frontimei: [{ type: "video" } /*, { type: "image" }*/],
                    frontmodel: [{ type: "video" } /*, { type: "image" }*/],
                },
            },
            ispace_md: {
                iphone: {
                    backsidebottomcorner: [{ type: "video" } /*, { type: "image" }*/],
                    backsidetopcorner: [{ type: "video" } /*, { type: "image" }*/],
                    front: [{ type: "video" } /*, { type: "image" }*/],
                    frontbattery: [{ type: "video" } /*, { type: "image" }*/],
                    frontimei: [{ type: "video" } /*, { type: "image" }*/],
                },
                smartphone: {
                    back: [{ type: "video" } /*, { type: "image" }*/],
                    backsidebottomcorner: [{ type: "video" } /*, { type: "image" }*/],
                    backsidetopcorner: [{ type: "video" } /*, { type: "image" }*/],
                    front: [{ type: "video" } /*, { type: "image" }*/],
                    frontimei: [{ type: "video" } /*, { type: "image" }*/],
                    frontmodel: [{ type: "video" } /*, { type: "image" }*/],
                },
            },
        },
    },
    kz: {
        en: {
            default: {
                iphone: {
                    backsidebottomcorner: [{ type: "video" } /*, { type: "image" }*/],
                    backsidetopcorner: [{ type: "video" } /*, { type: "image" }*/],
                    front: [{ type: "video" } /*, { type: "image" }*/],
                    frontbattery: [{ type: "video" } /*, { type: "image" }*/],
                    frontimei: [{ type: "video" } /*, { type: "image" }*/],
                },
                smartphone: {
                    back: [{ type: "video" } /*, { type: "image" }*/],
                    backsidebottomcorner: [{ type: "video" } /*, { type: "image" }*/],
                    backsidetopcorner: [{ type: "video" } /*, { type: "image" }*/],
                    front: [{ type: "video" } /*, { type: "image" }*/],
                    frontimei: [{ type: "video" } /*, { type: "image" }*/],
                    frontmodel: [{ type: "video" } /*, { type: "image" }*/],
                },
            },
        },
        ru: {
            default: {
                iphone: {
                    backsidebottomcorner: [{ type: "video" } /*, { type: "image" }*/],
                    backsidetopcorner: [{ type: "video" } /*, { type: "image" }*/],
                    front: [{ type: "video" } /*, { type: "image" }*/],
                    frontbattery: [{ type: "video" } /*, { type: "image" }*/],
                    frontimei: [{ type: "video" } /*, { type: "image" }*/],
                },
                smartphone: {
                    back: [{ type: "video" } /*, { type: "image" }*/],
                    backsidebottomcorner: [{ type: "video" } /*, { type: "image" }*/],
                    backsidetopcorner: [{ type: "video" } /*, { type: "image" }*/],
                    front: [{ type: "video" } /*, { type: "image" }*/],
                    frontimei: [{ type: "video" } /*, { type: "image" }*/],
                    frontmodel: [{ type: "video" } /*, { type: "image" }*/],
                },
            },
        },
        kz: {
            default: {
                iphone: {
                    backsidebottomcorner: [{ type: "video" } /*, { type: "image" }*/],
                    backsidetopcorner: [{ type: "video" } /*, { type: "image" }*/],
                    front: [{ type: "video" } /*, { type: "image" }*/],
                    frontbattery: [{ type: "video" } /*, { type: "image" }*/],
                    frontimei: [{ type: "video" } /*, { type: "image" }*/],
                },
                smartphone: {
                    back: [{ type: "video" } /*, { type: "image" }*/],
                    backsidebottomcorner: [{ type: "video" } /*, { type: "image" }*/],
                    backsidetopcorner: [{ type: "video" } /*, { type: "image" }*/],
                    front: [{ type: "video" } /*, { type: "image" }*/],
                    frontimei: [{ type: "video" } /*, { type: "image" }*/],
                    frontmodel: [{ type: "video" } /*, { type: "image" }*/],
                },
            },
        },
    },
    ua: {
        ua: {
            default: {
                iphone: {
                    backsidebottomcorner: [{ type: "video" } /*, { type: "image" }*/],
                    backsidetopcorner: [{ type: "video" } /*, { type: "image" }*/],
                    front: [{ type: "video" } /*, { type: "image" }*/],
                    frontbattery: [{ type: "video" } /*, { type: "image" }*/],
                    frontimei: [{ type: "video" } /*, { type: "image" }*/],
                },
                smartphone: {
                    back: [{ type: "video" } /*, { type: "image" }*/],
                    backsidebottomcorner: [{ type: "video" } /*, { type: "image" }*/],
                    backsidetopcorner: [{ type: "video" } /*, { type: "image" }*/],
                    front: [{ type: "video" } /*, { type: "image" }*/],
                    frontimei: [{ type: "video" } /*, { type: "image" }*/],
                    frontmodel: [{ type: "video" } /*, { type: "image" }*/],
                },
            },
        },
        ru: {
            default: {
                iphone: {
                    backsidebottomcorner: [{ type: "video" } /*, { type: "image" }*/],
                    backsidetopcorner: [{ type: "video" } /*, { type: "image" }*/],
                    front: [{ type: "video" } /*, { type: "image" }*/],
                    frontbattery: [{ type: "video" } /*, { type: "image" }*/],
                    frontimei: [{ type: "video" } /*, { type: "image" }*/],
                },
                smartphone: {
                    back: [{ type: "video" } /*, { type: "image" }*/],
                    backsidebottomcorner: [{ type: "video" } /*, { type: "image" }*/],
                    backsidetopcorner: [{ type: "video" } /*, { type: "image" }*/],
                    front: [{ type: "video" } /*, { type: "image" }*/],
                    frontimei: [{ type: "video" } /*, { type: "image" }*/],
                    frontmodel: [{ type: "video" } /*, { type: "image" }*/],
                },
            },
        },
    },
    za: {
        en: {
            default: {
                iphone: {
                    backsidebottomcorner: [{ type: "video" }],
                    backsidetopcorner: [{ type: "video" }],
                    front: [{ type: "video" }],
                    frontbattery: [{ type: "video" }],
                    frontimei: [{ type: "video" }],
                },
            },
        },
    },
};
